import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Smartphone, X } from 'lucide-react';
import { Card } from '@core/components/Card';
import { useUser } from '@core/contexts/ProfileContext';
import { coreRuntime } from '@core/runtime';

const DISMISS_KEY = 'phone-link-banner-dismissed-at';
const DISMISS_FOR_MS = 7 * 24 * 60 * 60 * 1000;

function dismissedRecently(): boolean {
  try {
    const at = Number(localStorage.getItem(DISMISS_KEY));
    return Number.isFinite(at) && at > 0 && Date.now() - at < DISMISS_FOR_MS;
  } catch {
    return false;
  }
}

/**
 * Клиенту Telegram без номера — напоминание привязать номер: с ним можно войти в ту же карточку через
 * браузер (PWA), когда Telegram недоступен. Только в мини-аппе: в PWA вход по номеру, номер есть всегда.
 * Скрывается крестиком на неделю.
 */
export function PhoneLinkBanner() {
  const { user } = useUser();
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(dismissedRecently);

  if (!coreRuntime().capabilities.telegram || !user || user.phone || hidden) {
    return null;
  }

  const dismiss = () => {
    setHidden(true);
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
    } catch {
      // localStorage недоступен — скроем до перезапуска
    }
  };

  return (
    <Card className="!p-3 bg-primary/5 border-primary/20" onClick={() => navigate('/qr-code')}>
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-primary/15 flex items-center justify-center flex-shrink-0">
          <Smartphone className="w-4 h-4 text-primary" />
        </div>
        <div className="flex-1 text-sm text-text-main">
          Привяжите номер — сможете входить через браузер, если Telegram недоступен
        </div>
        <button
          type="button"
          aria-label="Скрыть"
          onClick={(e) => {
            e.stopPropagation();
            dismiss();
          }}
          className="p-1 -mr-1 text-text-muted rounded-full hover:bg-secondary/50"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </Card>
  );
}
